
import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData, updateData, deleteData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import { TableCell, TableContainer, Tooltip, Paper, Table, TableHead, TableBody, TableRow } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Modal from '@mui/material/Modal';
import Select from 'react-select';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faSave, faTrash } from '@fortawesome/free-solid-svg-icons';

const ItemEdit = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);


    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const [formData, setFormData] = useState({
        Code: '',
        SearchableName: '',
        Name: '',
        TaxRate: '0',
        HSNCode: '',
        MRP: '0',
        PurchaseRate: '0',
        SaleRate: '0',
    });

    //  Item Category

    const [CategoryTypeOptions, setCategoryTypeOptions] = useState([]);
    const [selectedCategoryType, setSelectedCategoryType] = useState("");

    const fetchCategoryType = async () => {
        try {

            const response = await fetchData('ItemCategoryApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(category => ({
                    value: category.Id,
                    label: category.Name
                }));
                setCategoryTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleCategoryTypeChange = (selectedOption) => {
        //setSelectedMasterType(selectedOption);
        setSelectedCategoryType(selectedOption);
    };

    useEffect(() => {
        fetchCategoryType();
    }, []);

    // UOM (UNIT OF MEASURES)

    const [MEASURESTypeOptions, setMEASURESTypeOptions] = useState([]);
    const [selectedMEASURESType, setSelectedMEASURESType] = useState("");

    const fetchMEASURESType = async () => {
        try {

            const response = await fetchData('UOMApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(uom => ({
                    value: uom.Id,
                    label: uom.Name
                }));
                setMEASURESTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleMEASURESTypeChange = (selectedOption) => {
        //setSelectedMasterType(selectedOption);
        setSelectedMEASURESType(selectedOption);
    };

    useEffect(() => {
        fetchMEASURESType();
    }, []);



    const [CustomerRateRelation, setCustomerRateRelation] = useState([]);
    useEffect(() => {
        fetchData('ItemApi', `/ItemEditData/${id}`, token)
            .then((response) => {
                console.log('API response:', response);
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    }, [id, userId, token]);



    const submitData = async () => {

        const ItemData = {
            Id: id,
            CompanyId: companyId,
            ItemCategoryId: selectedCategoryType.value || formData.ItemCategoryId,
            UnitofMeasureId: selectedMEASURESType.value || formData.UnitofMeasureId,
            Name: formData.Name,
            Code: formData.Code,
            TaxRate: formData.TaxRate,
            PurchaseRate: formData.PurchaseRate,
            WholesaleRate: formData.WholesaleRate,
            RetailRate: formData.RetailRate,
            BtoCRate: formData.BtoCRate,
            ExpiryDays: formData.ExpiryDays,
            MRP: formData.MRP,
            HSNCode: formData.HSNCode,
            BarCode: formData.BarCode,
            CreatedBy: formData.CreatedBy,
            CreatedDate: formData.CreatedDate,
            IsActive: formData.IsActive,
            MinRequiredQty: formData.MinRequiredQty,
            UpdatedBy: userId,
            UpdateDate: new Date(),
        };


        try {
            const response = await updateData('ItemApi', id, ItemData, token);
            console.log('Record updated successfully:', response);

            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);

            history.push('/ItemIndex');

        } catch (error) {
            console.error('Error updating record:', error);
        }
    };


    const [editIndex, setEditIndex] = useState(null);
    const [editedData, setEditedData] = useState({});

    const handleEditClick = (index) => {
        setEditIndex(index);
        setEditedData(CustomerRateRelation[index]);
    };

    const handleInputChange = (field, value) => {
        setEditedData({
            ...editedData,
            [field]: value,
        });
    };

    const handleSaveClick = (index) => {
        handleEditChange(index, editedData);
        setEditIndex(null);
    };

    const handleEditChange = (index, updatedData) => {

        const updatedSlabs = CustomerRateRelation.map((slab, idx) =>
            idx === index ? updatedData : slab
        );
        setCustomerRateRelation(updatedSlabs);
    };

    const handleChange = (event) => {
        const { name, value, type } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));
    };


    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '101%' }}>
                <form onSubmit={submitData}>
                    <div className='w-full mb-2 flex'>
                        <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Item Edit</h6>

                        <Button
                            style={{ marginLeft: '8px', color: 'darkgreen', fontWeight: 'bolder', marginTop: '-30px' }}
                            onClick={submitData}
                            disabled={isLoading}
                        >
                            <DoneIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} />
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>SAVE</b>}
                        </Button>

                        <Button
                            component={Link}
                            to="/ItemIndex"
                            className="linkcolor"
                            style={{ marginLeft: '8px', color: 'brown', fontWeight: 'bolder', marginTop: '-30px' }}
                        >
                            <ReplyAllIcon style={{ marginLeft: '8px', color: 'brown', fontWeight: 'bolder' }} /> BACK TO LIST
                        </Button>
                    </div>

                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="watermark">
                        <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                    </div>


                    <div className="w-full flex flex-wrap">
                        <div className="w-full" style={{ padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>
                            <div className="w-full mb-3 flex" >
                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Code<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.Code}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Code"
                                        name='Code'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>
                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Name<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.Name}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Name"
                                        name='Name'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                                <div className="w-1/3 mr-2">

                                    <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        Category
                                    </label>

                                    <Select
                                        value={selectedCategoryType || (formData.ItemCategoryName ? { value: formData.ItemCategoryId, label: formData.ItemCategoryName } : '')}
                                        onChange={handleCategoryTypeChange}
                                        options={CategoryTypeOptions}
                                        placeholder="Category"
                                        isSearchable
                                    />
                                </div>
                                <div className="w-1/6 mr-2">

                                    <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        UOM
                                    </label>

                                    <Select
                                        value={selectedMEASURESType || (formData.UnitofMeasureName ? { value: formData.UnitofMeasureId, label: formData.UnitofMeasureName } : '')}
                                        onChange={handleMEASURESTypeChange}
                                        options={MEASURESTypeOptions}
                                        placeholder="UOM"
                                        isSearchable
                                    />

                                </div>

                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Bar Code<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.BarCode}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Bar Code"
                                        style={{ textAlign: 'left' }}
                                        name='BarCode'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Packet Weight (g) <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.PacketsInGrams}
                                        onChange={handleChange}
                                        type="number"
                                        placeholder="In Grams"
                                        style={{ textAlign: 'left' }}
                                        name='PacketsInGrams'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        No. of Units/Pkt.<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.NoOfUnitPacking}
                                        onChange={handleChange}
                                        type="number"
                                        placeholder="No.of Packing"
                                        style={{ textAlign: 'left' }}
                                        name='NoOfUnitPacking'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                            </div>

                            <div className="w-full mb-3 flex" style={{ marginTop: '10px' }}>

                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Tax Rate<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.TaxRate}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Tax Rate"
                                        style={{ textAlign: 'right' }}
                                        name='TaxRate'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>
                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        HSN Code<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.HSNCode}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="HSN Code"
                                        name='HSNCode'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>
                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Purchase Rate<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.PurchaseRate}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Purchase Rate"
                                        style={{ textAlign: 'right' }}
                                        name='PurchaseRate'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        WholeSale Rate<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.WholesaleRate}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Whole sale Rate"
                                        style={{ textAlign: 'right' }}
                                        name='WholesaleRate'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Retail Rate<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.RetailRate}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Retail Rate"
                                        style={{ textAlign: 'right' }}
                                        name='RetailRate'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        BtoC Rate<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.BtoCRate}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="BtoC Rate"
                                        style={{ textAlign: 'right' }}
                                        name='BtoCRate'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Expiry Days<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.ExpiryDays}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Expiry Days"
                                        style={{ textAlign: 'right' }}
                                        name='ExpiryDays'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Min. Req. Qty<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.MinRequiredQty}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Min Required Qty"
                                        style={{ textAlign: 'right' }}
                                        name='MinRequiredQty'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </form>
            </div >
        </Fragment >
    );
};

export default ItemEdit;